/* eslint-disable react-hooks/exhaustive-deps */
import CommonFormBuilder from "@/app/components/common-form-builder/CommonFormBuilder";
import React, { useEffect, useState } from "react";
import { FieldValues, UseFormReturn } from "react-hook-form";
import DisabledMethodMSg from "../../checkout-error-messages/DisabledMethodMSg";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { IField } from "@/api/AppApi/services/builder/interfaces/interfaces";
import {
  RecievingFields,
  defaultAddressFields,
} from "../receiving-settings-helpers/helpers";
import { useAtom } from "jotai";
import { receivingSettingsAtom } from "@/hooks/receivingHeaderAtom";
import { IKeyValue } from "@/api/AppApi/services/filters/interfaces/IGetFilters";

interface props {
  form: UseFormReturn<FieldValues, any>;
}

const GuestAddressSection: React.FC<props> = ({ form }) => {
  const getCompany = useGetCompanyQuery();
  const countries = getCompany?.data?.result?.countries;
  const [receivingSetting] = useAtom(receivingSettingsAtom);
  const shipingSettings = getCompany?.data?.result?.shipping_settings;
  const [addressFields, setAddressFields] =
    useState<IField[]>(defaultAddressFields);

  useEffect(() => {
    setAddressFields((addressFields) => [
      ...addressFields.map((field) => ({
        ...field,
        data: (field.configurations.key === RecievingFields.counteryField
          ? countries?.map(
              (country): IKeyValue => ({
                key: country.id?.toString()!,
                value: country?.name!,
              }),
            )
          : null)!,
      })),
    ]);
  }, [countries]);
  useEffect(() => {
    if (receivingSetting) {
      form.reset({
        ...form.getValues(),
        [RecievingFields.addressNameField]:
          receivingSetting?.address?.address_name,
        [RecievingFields.areaField]: receivingSetting?.address?.area_id,
        [RecievingFields.cityField]: receivingSetting?.address?.city_id,
        [RecievingFields.counteryField]: receivingSetting?.address?.country_id,
      });
    }
  }, [receivingSetting, countries]);
  return (
    <div className="d-flex gap-2 flex-column pb-5">
      {shipingSettings?.enable_shipping ? (
        <>
          {addressFields?.map((field) => (
            <CommonFormBuilder
              key={field.configurations.key}
              field={field}
              form={form}
              isGetKeyValue
            />
          ))}
        </>
      ) : (
        <DisabledMethodMSg
          message={shipingSettings?.shipping_not_available_message!}
        />
      )}
    </div>
  );
};

export default GuestAddressSection;
